'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Glyph;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _group = require('@vx/group');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Glyph.propTypes = {
  top: _propTypes2.default.number,
  left: _propTypes2.default.number,
  className: _propTypes2.default.string,
  children: _propTypes2.default.any
};

function Glyph(_ref) {
  var _ref$top = _ref.top,
      top = _ref$top === undefined ? 0 : _ref$top,
      _ref$left = _ref.left,
      left = _ref$left === undefined ? 0 : _ref$left,
      className = _ref.className,
      children = _ref.children;

  return _react2.default.createElement(
    _group.Group,
    { className: (0, _classnames2.default)('vx-glyph', className), top: top, left: left },
    children
  );
}